export const setAppEnv = (env) => ({
    type: 'SET_APP_ENV',
    data: { environment: env }
})

// module.exports = {
//     setAppEnv: setAppEnv,
// }